export const logoMap = {
  78: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Brighton.png', // BHA - Brighton
  8: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Liverpool.png', // LIV - Liverpool
  19: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Arsenal.png', // ARS - Arsenal
  15: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/AstonVilla.png', // AVL - Aston Villa,
  14: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/ManchesterUnited.png', // MUN - Manchester united,
  52: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Bournemouth.png', // BOU - Bournemouth,
  18: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Chelsea.png', // CHE - Chelsea,
  51: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/CrystalPalace.png', //  -Crystal Palace,
  13: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Everton.png', // EVE - Everton,
  11: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Fulham.png', // FUL -Fulham,
  115: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/LutonTown.png', // LUT -Luton Town,
  20: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/NewCastle.png', // NEW - NewCastle,
  63: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/NottinghamForest.png', // NFO - Nottingham Forest",
  6: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Tottenham.png', // TOT - Tottenham,
  21: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Sheffield.png', // SHU - Sheffield United,
  1: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/WestHam.png', // WHU - WestHam
  29: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Wolves.png', // WOL - Wolves,
  236: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Brentford.png', // BRE - Brentford,
  9: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/ManchesterCity.png', // MCI - Manchester City,
  71: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/LeedsUnited.png', // LEE - Leads united,
  3: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Sunderland.png', // SUN - Sunderland,
  27: 'https://d39w1y7zszvk6t.cloudfront.net/logos/EPL/Burnley.png', // BUR -  Burnley,

  // demoted 3
  65: 'https://d39w1y7zszvk6t.cloudfront.net/logos/Southampton.png', // SOU - Southampton,
  116: 'https://d39w1y7zszvk6t.cloudfront.net/logos/Ipswich.png', // IPS - Ipswich Town,
  42: 'https://d39w1y7zszvk6t.cloudfront.net/logos/LeicesterCity.png', // LEI  - Leicester City,

  // UCL
  591: 'https://d39w1y7zszvk6t.cloudfront.net/logos/UCL/PSG.png',
  503: 'https://d39w1y7zszvk6t.cloudfront.net/logos/UCL/BayernMunich.png',
  68: 'https://d39w1y7zszvk6t.cloudfront.net/logos/UCL/Dortmund.png',
  2930: 'https://d39w1y7zszvk6t.cloudfront.net/logos/UCL/InterMilan.png',

  // LaLiga
  2975: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Alaves.png', // Alaves
  13258: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/AthleticClub.png', // Athletic Club
  7980: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/AtleticoMadrid.png', // Atletico Madrid
  83: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Barcelona.png', // Barcelona
  36: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/CeltaDeVigo.png', // Celta Vigo
  1099: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Elche.png', // Elche
  528: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Espanyol.png', // Espanyol
  106: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Getafe.png', // Getafe
  231: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Girona.png', // Girona
  3457: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Levante.png', // Levante
  645: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Mallorca.png', // Mallorca
  459: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Osasuna.png', // Osasuna
  377: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/RayoVallecano.png', // Vallecano
  485: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/RealBetis.png', // Real Betis
  3468: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/RealMadrid.png', // Real Madrid
  93: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/RealOviedo.png', // Real Oviedo
  594: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/RealSociedad.png', // Real Sociedad
  676: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Sevilla.png', // Sevilla
  214: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Valencia.png', // Valencia
  3477: 'https://d39w1y7zszvk6t.cloudfront.net/logos/laliga/Villarreal.png', // Villarreal

  // club world cup
  460: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/AlAhly.png', // AlAhly
  7780: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/AlAin.png', // AlAin
  7011: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/AlHilal.png', // AlHilal
  1022: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/NewAucklandCityFC.png', // Auckland City
  605: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/SLBenfica.svg.png', // Benefica
  587: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/BocaJuniors.png', // BocaJuniors
  2864: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/BotafogoDeFutebol.png', // Botafogo
  5832: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/EsperanceSportiveDeTunis.png', // ES Tunis
  1024: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/FlamengoEsports.png', // Flamengo
  1095: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/FFCcrest.png', // Fluminense
  239235: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/InterMiami.png', // Inter Miami
  625: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/juventusfclogo.png', // Juventus
  147671: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/LosAngeles.png', // Los Angeles
  6755: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/MamelodiSundownsFC.png', // Mamelodi Sundowns
  2662: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/ClubDeFutbolMonterrey.png', // Monterrey
  10036: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/PachucaTuzos.png', // Pachuca
  3422: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/Palmeiras.png', // Palmeiras
  652: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/FCPorto.png', // Porto
  49: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/FCRedBullSalzburg.png', // Salzburg
  10002:
    'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/EscudodelCARiverPlate.png', // River Plate
  2649: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/SeattleSounders.png', // Seattle Sounders
  280: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/UrawaRedDiamonds.png', // Juventus
  5839: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/UlsanHyundai.png', // Ulsan HD
  2846: 'https://d39w1y7zszvk6t.cloudfront.net/logos/cwc/WydadACcrest.png', // Casablanca
}
